import { Link } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import FirmLogo from "../../Images/FirmLogo";

const LatestJobListingResultBlock = (props) => {
  const { jobList, handleRemoveJob } = props;
  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;

  const displayDiscription = (discription) => {
    if (discription.length > 400) {
      return discription.substr(0, 400) + "...";
    } else {
      return discription;
    }
  };

  const removeJob = (jobSlug) => {
    handleRemoveJob(jobSlug);
  };

  const jobItem = (item) => {
    return (
      <div className="card mb-3" key={item.job_id}>
        <div className="card-body">
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start ">
            <div className="d-flex">
              <div className="d-block">
                <h2>
                  <Link to={`/job/details/${item.job_slug}`}>
                    <span className="text-dark">
                      #{item.job_id} {item.job_title}
                    </span>
                  </Link>
                </h2>

                <div className="d-flex mt-1 align-items-center flex-wrap text-sm text-muted">
                  {item.employer_name && <span>{item.employer_name}</span>}

                  {item.employer_name && item.job_type && (
                    <span
                      className="mx-2"
                      style={{ opacity: 0.3, fontSize: "1.2rem" }}
                    >
                      •
                    </span>
                  )}

                  {item.job_type && (
                    <span className="badge badge-info" title={item.job_type}>
                      {item.job_type}
                    </span>
                  )}

                  {(item.employer_name || item.job_type) &&
                    item.location_requirement && (
                      <span
                        className="mx-2"
                        style={{ opacity: 0.3, fontSize: "1.2rem" }}
                      >
                        •
                      </span>
                    )}

                  {item.location_requirement && (
                    <span>
                      <i className="bi bi-geo-alt-fill me-1 text-muted"></i>
                      {item.location_requirement}
                    </span>
                  )}

                  {(item.employer_name ||
                    item.job_type ||
                    item.location_requirement) &&
                    item.created_on && (
                      <span
                        className="mx-2"
                        style={{ opacity: 0.3, fontSize: "1.2rem" }}
                      >
                        •
                      </span>
                    )}

                  {item.created_on && (
                    <span>
                      <i className="bi bi-calendar-event me-1 text-muted"></i>
                      Posted on{" "}
                      {new Date(item.created_on).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-center">
              <div className="mt-3 mt-lg-0 d-flex gap-3">
                <FirmLogo url={item?.firm_logo} />
                {user_slug === item.user_slug ? (
                  <>
                    <Link to={`/job/edit/${item.job_slug}`}>
                      <div
                        className="icon-holder-sm icon-holder-success cursor-pointer"
                        title="Edit"
                      >
                        <FontAwesomeIcon icon={faPen} />
                      </div>
                    </Link>

                    <div
                      className="icon-holder-sm icon-holder-danger cursor-pointer"
                      title="Delete"
                      onClick={() => removeJob(item.job_slug)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>

          <div className="d-block mt-3">
            <span className="">{displayDiscription(item.job_description)}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="d-block">
      {jobList
        ? jobList.map(function (item) {
            return jobItem(item);
          })
        : null}
    </div>
  );
};

export default LatestJobListingResultBlock;
